// Banner de vencimiento en Inicio (comercial-avisos-vencimiento S2). Función pura: decide, a partir del resumen de
// GET /suscripciones/resumen, si hay que avisar y con qué texto. Sin red, sin fechas del navegador: los días ya vienen
// calculados por el backend (`dias_para_vencimiento`, `dias_retraso`, `dias_para_corte`).

// Solo administradores del tenant (id_rol 1 y 2) ven el aviso.
export const ROLES_CON_AVISO = [1, 2];

// Con más días que estos todavía no se avisa.
export const DIAS_AVISO_ANTICIPADO = 7;

export function rolVeAvisos(idRol) {
  return ROLES_CON_AVISO.includes(Number(idRol));
}

function dias(cantidad) {
  return `${cantidad} ${cantidad === 1 ? "día" : "días"}`;
}

function numeroOnull(valor) {
  if (valor === null || valor === undefined || valor === "") return null;
  const n = Number(valor);
  return Number.isFinite(n) ? n : null;
}

// Mismo criterio que el calendario del backend (cubiertoPorSaldo): el saldo del libro es deuda en positivo.
// Antes de vencer, solo un crédito (saldo < 0) silencia; desde el día del vencimiento alcanza con no deber (saldo <= 0).
function cubiertoPorSaldo(saldo, diasParaVencimiento) {
  const s = numeroOnull(saldo);
  if (s === null) return false;
  return diasParaVencimiento > 0 ? s < 0 : s <= 0;
}

/**
 * @param {object|null} resumen respuesta de GET /suscripciones/resumen
 * @returns {{nivel: 'warning'|'error', texto: string}|null}
 */
export function textoBannerVencimiento(resumen) {
  if (!resumen || resumen.avisos_habilitados !== true) return null;

  const d = numeroOnull(resumen.dias_para_vencimiento);
  if (d === null || d > DIAS_AVISO_ANTICIPADO) return null;
  if (cubiertoPorSaldo(resumen.saldo, d)) return null;

  if (d > 0) return { nivel: "warning", texto: `Tu plan vence en ${dias(d)}.` };
  if (d === 0) return { nivel: "warning", texto: "Tu plan vence hoy." };

  const paraCorte = numeroOnull(resumen.dias_para_corte);
  if (resumen.estado_comercial === "suspendido" || paraCorte === 0) {
    return { nivel: "error", texto: "Tu cuenta está suspendida por falta de pago." };
  }

  const retraso = `Tu plan está vencido: ${dias(-d)} de retraso`;
  return {
    nivel: "error",
    texto: paraCorte === null ? `${retraso}.` : `${retraso}; se suspende en ${dias(paraCorte)}.`,
  };
}
